export default __webpack_public_path__ + "static/media/Frame.fb9adb8a.svg";